export class DocumentoPessoa {
    static CarregarDocumentos(docn: DocumentoPessoa): DocumentoPessoa {
        let doc = new DocumentoPessoa();
        doc.codigoPessoaFisica = docn.codigoPessoaFisica;
        doc.numeroRg = docn.numeroRg;
        doc.codigoUfRg = docn.codigoUfRg;
        doc.emissaoRg = docn.emissaoRg;
        doc.orgaoEmissorRg = docn.orgaoEmissorRg;

        doc.titulo = docn.titulo;
        doc.zonaTitulo = docn.zonaTitulo;
        doc.secaoTitulo = docn.secaoTitulo;
        doc.codigoCidadeTitulo = docn.codigoCidadeTitulo;
        doc.codigoUfTitulo = docn.codigoUfTitulo;
        doc.emissaoTitulo = docn.emissaoTitulo;

        doc.ctpsEmissao = docn.ctpsEmissao;
        doc.ctpsNumero = docn.ctpsNumero;
        doc.ctpsSerie = docn.ctpsSerie;
        doc.ctpsUf = docn.ctpsUf;

        doc.pisInscricao = docn.pisInscricao;
        doc.pisNumero = docn.pisNumero;

        doc.cnhNumero = docn.cnhNumero;
        doc.cnhOrgaoEmissor = docn.cnhOrgaoEmissor;
        doc.cnhUf = docn.cnhUf;
        doc.cnhEmissao = docn.cnhEmissao;
        doc.cnhCategoria = docn.cnhCategoria;
        doc.cnhPrimeiraEmissao = docn.cnhPrimeiraEmissao;
        doc.cnhValidade = docn.cnhValidade;

        doc.reservistaNumero = docn.reservistaNumero;
        doc.reservistaSerie = docn.reservistaNumero;
        doc.reservistaCategoria = docn.reservistaCategoria;
        doc.reservistaUf = docn.reservistaUf;
        doc.reservistaOrgaoEmissor = docn.reservistaOrgaoEmissor;
        doc.reservistaForca = docn.reservistaForca;
        doc.reservistaEmissao = docn.reservistaEmissao;

        doc.conselhoRegionalNumero = docn.conselhoRegionalNumero;
        doc.conselhoRegionalOrgao = docn.conselhoRegionalOrgao;
        doc.conselhoRegionalUf = docn.conselhoRegionalUf;
        doc.conselhoRegionalEmissao = docn.conselhoRegionalEmissao;
        doc.conselhoRegionalRegiao = docn.conselhoRegionalRegiao;
        doc.conselhoRegionalProtocolo = docn.conselhoRegionalProtocolo;
        doc.conselhoRegionalValidade = docn.conselhoRegionalValidade;

        return doc;
    }
    

    codigoPessoaFisica: number;
    numeroRg: string;
    codigoUfRg: number;
    emissaoRg: Date;
    orgaoEmissorRg: string;

    titulo: number;
    zonaTitulo: number;
    secaoTitulo: number;
    codigoCidadeTitulo: number;
    codigoUfTitulo: number;
    emissaoTitulo: Date;

    ctpsNumero: number;
    ctpsSerie: number;
    ctpsUf: number;
    ctpsEmissao: Date;

    pisNumero: number;
    pisInscricao: Date;

    cnhNumero: number;
    cnhOrgaoEmissor: string;
    cnhUf: number;
    cnhEmissao: Date;
    cnhCategoria: number;
    cnhPrimeiraEmissao: Date;
    cnhValidade: Date;

    reservistaNumero: string;
    reservistaSerie: string;
    reservistaCategoria: number;
    reservistaUf: number;
    reservistaOrgaoEmissor: string;
    reservistaForca: number;
    reservistaEmissao: Date;

    conselhoRegionalNumero: number;
    conselhoRegionalOrgao: string;
    conselhoRegionalUf: number;
    conselhoRegionalEmissao: Date;
    conselhoRegionalRegiao: string;
    conselhoRegionalProtocolo: string;
    conselhoRegionalValidade: Date;

}


// WEBPACK FOOTER //
// ./src/app/models/documento-pessoa.model.ts